export const formationGroupsFr = {
  title: "Groupes de formation",
  subtitle:
    "Un groupe de formation rassemble les participants d'une même formation et choisit les objectifs qui leur sont présentés.",
  create: "Créer un groupe de formation",
  edit: "Modifier",
  reset: "Réinitialiser",
  delete: "Supprimer",
  cancel: "Annuler",
  save: "Enregistrer",
  back: "Retour",
  error: "Une erreur est survenue. Veuillez réessayer.",
  list: {
    name: "Nom",
    participants: "Participants",
    createdAt: "Date de création",
    actions: "Actions",
    view: "Voir",
    empty: "Aucun groupe de formation pour le moment.",
  },
  form: {
    nameLabel: "Nom du groupe",
    namePlaceholder: "Atelier gestion des matières résiduelles",
    nameRequired: "Veuillez saisir un nom pour le groupe de formation.",
    goalsLabel: "Objectifs présentés aux participants",
    goalsHelp:
      "Les participants de ce groupe verront ces objectifs, et ceux-là seulement.",
    goalsRequired: "Le groupe doit conserver au moins un objectif.",
    ofTotal: "/ {{total}} objectifs présentés aux participants",
    emptyThematics: "Aucun objectif retenu en {{thematics}}",
    searchGoal: "Chercher un objectif",
    searchGoalPlaceholder: "Chercher un objectif…",
    allIssues: "Tous les enjeux",
    searchIssue: "Chercher un enjeu…",
    noIssueMatches: "Aucun enjeu ne correspond.",
    filterByState: "Filtrer par état",
    thematic: "Thématique",
    status: {
      all: "Tous",
      on: "Sélectionnés",
      off: "Non sélectionnés",
    },
    shown_one: "{{count}} objectif affiché",
    shown_other: "{{count}} objectifs affichés",
    selectAll: "Tout sélectionner",
    clearAll: "Tout retirer",
    selectShown_one: "Sélectionner le {{count}} affiché",
    selectShown_other: "Sélectionner les {{count}} affichés",
    clearShown_one: "Retirer le {{count}} affiché",
    clearShown_other: "Retirer les {{count}} affichés",
    scope: "{{selected}} / {{shown}} sélectionnés dans ce filtre",
    reset: "Rétablir la sélection initiale ({{count}})",
    resetHint:
      "Rétablit la sélection du départ, quels que soient les filtres actifs",
    resetNoop: "La sélection est déjà celle du départ",
    noGoalMatches: "Aucun objectif ne correspond à ce filtre.",
    createTitle: "Créer un groupe de formation",
    editTitle: "Modifier le groupe de formation",
    createSubmit: "Créer le groupe",
  },
  participantProfileTitle: "Profil d'entreprise du participant",
  enrolment: {
    title: "Inscriptions",
    code: "Code d'inscription",
    open: "Inscriptions ouvertes",
    closed: "Inscriptions fermées",
    openShort: "Ouvertes",
    closedShort: "Fermées",
    openAction: "Ouvrir les inscriptions",
    close: "Fermer les inscriptions",
    regenerate: "Régénérer le code",
    usableHint:
      "Les participants peuvent saisir ce code pour rejoindre le groupe.",
    closedHint:
      "Le code ne fonctionne pas tant que les inscriptions sont fermées.",
    link: "Lien d'inscription",
    copyLink: "Copier le lien",
    linkCopied: "Lien copié.",
    linkCopyFailed: "Impossible de copier le lien.",
  },
  regenerateDialog: {
    title: "Régénérer le code d'inscription",
    body:
      "Le code « {{code}} » cessera de fonctionner immédiatement et sera remplacé par un nouveau code.",
    participants:
      "Les participants déjà inscrits gardent leur accès et leur travail.",
  },
  toasts: {
    created: "Le groupe de formation « {{name}} » a été créé.",
    opened:
      "Les inscriptions au groupe « {{name}} » sont ouvertes. Son code est {{code}}.",
    closed:
      "Les inscriptions au groupe « {{name}} » sont fermées. Les participants déjà inscrits gardent leur accès et leur travail.",
    regenerated:
      "Le code du groupe « {{name}} » est maintenant {{code}}. L'ancien code ne fonctionne plus.",
    updated: "Le groupe de formation « {{name}} » a été modifié.",
    deleted: "Le groupe de formation « {{name}} » a été supprimé.",
    participantRemoved: "{{participant}} a été retiré du groupe de formation.",
    reset_zero:
      "Le groupe « {{name}} » ne comptait aucun participant. Son nouveau code est {{code}} ; l'ancien ne fonctionne plus.",
    reset_one:
      "{{count}} participant a été retiré du groupe « {{name}} ». Son nouveau code est {{code}} ; l'ancien ne fonctionne plus.",
    reset_other:
      "{{count}} participants ont été retirés du groupe « {{name}} ». Son nouveau code est {{code}} ; l'ancien ne fonctionne plus.",
    profileUpdated: "Le profil d'entreprise de {{participant}} a été modifié.",
  },
  detail: {
    participants: "Participants",
    participantCount_one: "{{count}} participant",
    participantCount_other: "{{count}} participants",
    goalCount_one: "{{count}} objectif sélectionné",
    goalCount_other: "{{count}} objectifs sélectionnés",
    noGoals: "Aucun objectif sélectionné.",
    close: "Fermer",
    editGoals: "Modifier la sélection",
    goals: "Objectifs présentés aux participants",
    participant: "Participant",
    data: "Données du participant",
    assessment: "Autoévaluation",
    actionPlan: "Plan d'action",
    profileOf: "Profil de {{name}} ({{email}}).",
    profile: "Profil d'entreprise",
    viewing: "Données de {{name}}",
    history: "Historique",
    remove: "Retirer",
    removeConfirm:
      "Retirer ce participant du groupe ? Son compte et ses réponses sont conservés.",
    noParticipants: "Aucun participant dans ce groupe pour le moment.",
    noProfile: "Aucune donnée tant que le profil d'entreprise n'est pas créé.",
    createdOn: "créé le",
  },
  resetDialog: {
    title: "Réinitialiser le groupe de formation",
    // Zero gets its own sentence rather than a count. French pluralises it as
    // the singular, so `body_one` would promise that one participant is about
    // to be removed from a group that holds none — and the action stays
    // available on an empty group, so the sentence has to exist. It no longer
    // says the reset changes nothing: the code is retired even here.
    body_zero: "Le groupe « {{name}} » ne compte aucun participant.",
    body_one: "{{count}} participant sera retiré du groupe « {{name}} ».",
    body_other: "{{count}} participants seront retirés du groupe « {{name}} ».",
    preserved:
      "Les comptes, les réponses, les plans d'action et les vitrines sont conservés. Le groupe garde son nom et son ensemble d'objectifs, et reste prêt pour la cohorte suivante.",
    confirm: "Réinitialiser",
  },
  deleteDialog: {
    title: "Supprimer le groupe de formation",
    body: "Le groupe « {{name}} » et ses adhésions seront supprimés.",
    accounts_one: "Le compte du participant et ses réponses ne sont pas touchés.",
    accounts_other:
      "Les comptes des {{count}} participants et leurs réponses ne sont pas touchés.",
  },
  steps: {
    none: "Profil d'entreprise non créé",
  },
} as const;
